'use strict'

###*
# Groupon LazyLoad
#
# Version:  0.0.3
#
# Based on jQuery Lazy Load v1.9.3 by Mika Tuupola
###

isInitialized = false

$window = $(window)

###*
# Determine image positions within the document
#
# @param   {Array} images[] - Array with images nodes
# @returns {Array} pos[]    - Array containing the current images position in the document
###
getElementPositions = (images) ->
  pos = []
  images = images.slice()
  while (img = images.shift())
    {top, left, right} = img.getBoundingClientRect()
    pos.push({ left, top, right })
  pos

###*
# Returns the top/bottom coordinate of the visible viewport in doc coords
#
# @returns {Object}
###
getFold = ->
  height: window.innerHeight
  width:  window.innerWidth

toLoadFilter = (img) -> not img.loaded and img.offsetHeight  # height == 0 indicates "hidden"

###*
# Filter out the `images` that are visible, but not yet loaded
#
# @param   {Array} images[] - Images to lazyload
# @returns {Array} toLoad[] - Images that haven't been loaded
###
getImagesToLoad = (images) -> images.filter toLoadFilter

###*
# Unbind the lazyloader event
###
unbindLazyloaderEvent = (settings) ->
  $(settings.container).off(settings.event) if settings.performantScroll
  return

###*
# Determine if an images is within the viewport + threshold
#
# @param   {Object}  fold      - Viewport information
# @param   {Object}  imgPos    - Image information
# @param   {Number}  threshold - Threshold to consider loading images within
# @returns {Boolean}
###
withinViewport = (fold, imgPos, threshold) ->
  {left, top, right} = imgPos
  # below the fold?
  return false  if top <= -threshold
  # above the top of the viewport?
  return false  if top >= fold.height + threshold
  # left the fold?
  return false  if left <= -threshold
  # right the fold?
  return false  if right >= fold.width + threshold

  return true

###
# progressive load image
###
progressiveLoad = (el, settings) ->
  if not el.loaded and $(el).hasClass('progressive-load')
    if (settings.isRetina and (highQualitySrc = el.getAttribute('data-high-quality-2x'))) or (highQualitySrc = el.getAttribute('data-high-quality'))
      highQualityImage = new Image()
      highQualityImage.style.display = 'none'
      $(highQualityImage).on 'load', ->
        if el.nodeName is 'IMG'
          el.src = highQualitySrc
        else
          el.style.backgroundImage = "url('#{ highQualitySrc }')"

        el.style['-webkit-filter'] = 'blur(0px)'
        el.style['filter'] = 'blur(0px)'

        el.parentNode.removeChild this

      highQualityImage.src = highQualitySrc
      el.parentNode.appendChild highQualityImage

  el.loaded = true
  return

allLazyImages = []

$.fn.lazyload = (options = {}) ->
  newImages = @get()

  resizeTimer = null

  OPTS =
    event: 'scroll.lazyload'
    threshold: 400
    skip_invisible: true
    skip_initial_check: false # true to prevent initial kick off of "onScroll" on page load
    container: window
    performantScroll: false
    isRetina: window.devicePixelRatio and window.devicePixelRatio > 1
    placeholder: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="

  settings = Object.assign({}, OPTS, options)

  ticking = false

  ###
  # Global scroll handler
  ###
  onScroll = ->
    ticking = false # enable requesting a new frame after we exit
    imagesNotLoaded = getImagesToLoad(allLazyImages)

    unless imagesNotLoaded.length # aborts if all lazy loaded images are loaded
      unbindLazyloaderEvent(settings)
      return

    fold = getFold()

    # show just-scrolled-in images - keep the rest in allLazyImages
    allLazyImages = []
    positions = getElementPositions(imagesNotLoaded)
    threshold = settings.threshold
    while (img = imagesNotLoaded.shift())
      pos = positions.shift()
      if withinViewport(fold, pos, threshold)
        $(img).triggerHandler('appear')
      else
        allLazyImages.push(img)
    return

  ###
  # Image loading handler
  ###
  loadImage = ->
    url = @getAttribute('data-original')
    srcset = @getAttribute('data-srcset')

    if settings.isRetina and (url2x = @getAttribute('data-original-2x'))
      url = url2x

    if @nodeName is 'IMG'
      @srcset = srcset if srcset
      @src = url
    else
      @style.backgroundImage = "url('#{ url }')"

    progressiveLoad(this, settings)
    @classList.remove('lazy-wl', 'lazy-load')
    @classList.add('lazy-loaded')
    return

  ###
  # Asynchronous scroll handler
  ###
  requestTick = ->
    if not ticking
      requestAnimationFrame(onScroll)
      ticking = true
    return

  initLazyLoading = (onScrollHandler) ->

    # hide all not-yet-loaded images and make them react to the "appear" event
    images = newImages.slice()
    while (img = images.shift())
      # src = '' means it's a lazy-loaded image
      if img.nodeName is 'IMG' and img.src is ''
        img.loaded = false
        img.src = settings.placeholder # set to our invisible pixel gif

    # when appear is triggered, load the original image
    $(newImages).one 'appear', loadImage

    unless settings.skip_invisible
      $(newImages).trigger('appear')
      return


    allLazyImages = allLazyImages.concat newImages

    if not isInitialized
      # only set the window resize handler once;
      # subsequent $(selector).lazyload calls should not re-register this one
      if resizeTimer is null
        $window.on 'resize', ->
          clearTimeout(resizeTimer)  if (resizeTimer)
          resizeTimer = setTimeout(onScrollHandler, 100)

      # Fire one scroll event per scroll. Not one scroll event per image.
      window.addEventListener 'scroll', requestTick, {passive: true}

      isInitialized = true

    $ ->
      unless settings.skip_initial_check
        requestTick()

  initLazyLoading(onScroll)


module.exports = {
  getElementPositions
  getFold
  getImagesToLoad
  withinViewport
}



// WEBPACK FOOTER //
// ./src/frontend/core/grpn-lazyload.coffee